import { render, staticRenderFns } from "./Frage_10.vue?vue&type=template&id=006d7a4a&"
import script from "./Frage_10.vue?vue&type=script&lang=js&"
export * from "./Frage_10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports